import { Component, NgModule, OnInit } from '@angular/core';
import { RefreshButtonComponent } from '../refresh-button/refresh-button.component';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [RefreshButtonComponent], // Declare the component here
  exports: [RefreshButtonComponent], // Export it so other modules can use it
  imports: [CommonModule]
})

export class CommonModuleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
